// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2525":"be67d2bf3c8928c1","5922":"7c2efee8193e9b5c"}[chunkId] + ".css";
};